import React, { useState, useEffect, useReducer } from "react";
import { Container, Nav } from "react-bootstrap";
import { AiOutlineRight, AiFillCopy } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../common/storeContext'
import { TENANT_BUCKET, GLOBAL_BUCKET, GAME_MENU_DATA, IMAGE_SIZE_DYNAMIC } from '../../common/constants'
import TransferBalanceDialog from '../../components/TransferBalanceDialog'
import ProductDetailsDialog from '../../components/ProductDetailsDialog'
import Loading from '../../components/Loading';
import Alert from '../../components/Alert'
import ImageWithPlaceholder from '../../components/ImageWithPlaceholder'
import { useMiddletier } from "../../common/middletier";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import { BsInfinity } from "react-icons/bs";


import "swiper/css";
import "swiper/css/pagination";
import "./template_01.css";

const DYNAMIC_ACTION = {
  SET_DEFAULT_DATA: 'SET_DEFAULT_DATA',
  SET_SHOW_DATA: 'SET_SHOW_DATA',
  SET_FILTER_TYPES: 'SET_FILTER_TYPES',
  SET_SELECTED_FILTER_TYPE: 'SET_SELECTED_FILTER_TYPE',
  SET_ALL_TYPES: 'SET_ALL_TYPES',
  UPDATE_COUNTDOWN: 'UPDATE_COUNTDOWN',
}

const initialDynamicData = {
  defaultData: [],
  showData: [],
  // filterTypes: [{ code: 'all', name: 'show_all' }],
  // selectedFilterType: { code: 'all', name: 'show_all' },
  allType: [],
  filterTypes: [{ code: 'ALL', name: 'show_all' }],
  selectedFilterType: 'ALL',
}

const dynamicReducer = (state, action) => {
  switch (action.type) {

    case DYNAMIC_ACTION.SET_DEFAULT_DATA: {
      const defaultData = action.payload
      return { ...state, defaultData };
    }

    case DYNAMIC_ACTION.SET_SHOW_DATA: {
      const showData = action.payload
      return { ...state, showData };
    }

    case DYNAMIC_ACTION.UPDATE_COUNTDOWN: {
      const updateCountdown = state.showData.map(promotion => ({
        ...promotion, remainingTime: action.payload(promotion)
      }));

      return { ...state, showData: updateCountdown };
    }


    case DYNAMIC_ACTION.SET_ALL_TYPES: {
      const allType = [...action.payload]
      return { ...state, allType };
    }

    case DYNAMIC_ACTION.SET_FILTER_TYPES: {
      const filterTypes = [...action.payload]
      return { ...state, filterTypes };
    }

    case DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE: {
      const selectedFilterType = state.filterTypes.find((filterTypes) => filterTypes.code === action.payload)
      // console.log('selectedFilterType',selectedFilterType)
      return { ...state, selectedFilterType };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

const Template_01 = (props) => {

  const appState = useStoreState()
  // const [dynamicData, setDynamicData] = useState();
  const [dynamicState, dynamicDispatch] = useReducer(dynamicReducer, initialDynamicData)
  const { query, queries, mutation } = useMiddletier();
  const appDispatch = useStoreDispatch()
  // const [remainingTime, setRemainingTime] = useState(null);
  const location = useLocation();
  const [productDetailsDialogShow, setProductDetailsDialogShow] = useState(false);

  const [transferDialogShow, setTransferDialogShow] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const navigate = useNavigate();
  const cardContainerProps = props.properties ? props.properties.find((itm) => itm.name === 'Card Container') : false
  const { desktopToggle, mobileToggle, label, id, dataType, titleToggle, titleIconToggle, dynamicQuery, data, filter, noPadding, filterTabToggle, cardPosition, noLink } = props;
  const isSafari = () => /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

  const checkProps = cardContainerProps ? cardContainerProps : props;
  const { contentPosition, actionPosition, rowDesktop, rowMobile, numberOfRow, folderImage } = checkProps
  const imageSize = cardContainerProps.image ? cardContainerProps.image : props.imageSize
  let imageSizeDynamic = ''
  const { t, i18n } = useTranslation();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const [deviceType, setDeviceType] = useState('');

  const onClickGame = (game) => {
    if (appState.loggedIn) {
      setLoading(true);
      // console.log('deviceType:', deviceType)
      let currentGame = {
        getCurrentGameType: '',
        getCurrentGameProvider: '',
        getCurrentGameCode: '',
        getCurrentGameUrl: ''
      }

      if (dataType === 'game provider') {
        // console.log(game)
        // console.log('game_provider_game_types',game._game_provider_game_types)
        currentGame.getCurrentGameType = game._game_provider_game_types[0].type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
      }
      else if (dataType === 'game') {
        currentGame.getCurrentGameType = game.type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
      } else {
        currentGame.getCurrentGameType = game.sub_type
        currentGame.getCurrentGameProvider = game.game_provider
        currentGame.getCurrentGameCode = game.code
      }
      const mytab = window.open("/loading.html", "_blank");

      let method = 'getGameLinkByMember';
      let params = [
        { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
        { code: 'device', graphqlType: 'String', required: false, value: deviceType === 'desktop' ? '0' : '1' },
        { code: 'gameType', graphqlType: 'String', required: true, value: currentGame.getCurrentGameType },
        { code: 'game', graphqlType: 'String', required: false, value: currentGame.getCurrentGameCode },
        { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
        { code: 'skipTransfer', graphqlType: 'Boolean', required: false, value: true },
      ];

      query({
        method,
        params,
        attributes: []

      }).then(({ data }) => {
        // setLoading(false)
        // console.log('getGameLinkByMember', data[method])

        const gameBalance = data[method].balance
        const gameUrl = data[method].gameLink
        const gameWalletAmount = data[method].wallet_amount
        currentGame.getCurrentGameUrl = gameUrl

        if (gameUrl === "") {
          setLoading(false);
          mytab.close()
          const getResponse = JSON.parse(data[method].response)
          const getResponseErrorMsg = getResponse?.errMsg

          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: getResponseErrorMsg, typeAlert: 'error' }
          });

          return
        } else {

          mytab.location = '/loading_transfer.html'

          mutation([{
            method: 'restoreGameWalletByMember',
            params: [
              { code: 'member', graphqlType: 'String', required: true, value: appState.user?.username },
              { code: 'gameProvider', graphqlType: 'String', required: true, value: currentGame.getCurrentGameProvider },
              { code: 'checkAutoTransfer', graphqlType: 'Boolean', required: false, value: true },
            ],
            attributes: []

          }])
            .then(({ data }) => {
              // console.log('data[restoreGameWalletByMember]', data['restoreGameWalletByMember'])

              mytab.location = gameUrl

              if (gameBalance === 0 && data['restoreGameWalletByMember'] === 0) {
                setLoading(false);
                setTransferDialogShow({ show: true, balance: gameBalance, gameSelect: { ...currentGame }, walletAmount: gameWalletAmount });
              }

              else {

                queries([{
                  index: 'getAllGamePrivoderBalanceByMember',
                  method: 'getAllGamePrivoderBalanceByMember',
                  params: [],
                  attributes: []
                },
                {
                  index: 'member',
                  method: 'member',
                  params: [
                    { code: 'username', graphqlType: 'String', required: true, value: appState.user?.username },
                  ],
                  attributes: ['wallet_amount']
                },])
                  .then(({ data }) => {

                    setLoading(false);

                    appDispatch({ type: APP_STORE_ACTION.REFRESH_GET_GAME_WALLET, payload: data['getAllGamePrivoderBalanceByMember'] })
                    appDispatch({ type: APP_STORE_ACTION.REFRESH_WALLET_AMOUNT, payload: data['member'].wallet_amount })


                  }).catch((error) => {
                    // console.log('error: ', error)
                    setLoading(false)
                    if (error?.networkError?.statusCode === 401) {
                      appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                    } else {
                      appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                      });
                    }
                  })

              }

            })
            .catch((error) => {
              // console.log('error: ', error)
              setLoading(false)
              if (error?.networkError?.statusCode === 401) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
              } else {
                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: error.message.toString(), typeAlert: 'error' }
                });
              }
            })
        }



      }).catch((error) => {
        mytab.close()
        setLoading(false);
        // console.log('error: ', error)
        if (error?.networkError?.statusCode === 401) {
          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
        } else {
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: error.message.toString(), typeAlert: 'error' }
          });
        }
      })
    }
    else {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: t('error_login_continue'), typeAlert: 'error' }
      });
    }

  }

  const onChangeType = (newValue) => {

    if (location.pathname === '/shop') {
      // navigate(`/shop#${newValue}`);
      dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE, payload: newValue })

    } else {
      // dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE, payload: newValue })
    }

  }

  const copyText = (newValue) => {
    navigator.clipboard.writeText(newValue);
    appDispatch({
      type: APP_STORE_ACTION.SHOW_ALERT,
      payload: { description: `Copied ${newValue ?? '-'}`, typeAlert: 'success' }
    });
  };


  const onChangeProductDetails = (item) => {
    setCurrentItem(item);
    setProductDetailsDialogShow(true);
  };

  // const onClickAddCart = (event, item) => {
  //   event.stopPropagation();


  //   let addCartProduct = []

  //   const getCartProduct = localStorage.getItem('cart_product');

  //   if (getCartProduct !== null) {
  //     addCartProduct = JSON.parse(getCartProduct) ?? null


  //     let checkProduct = addCartProduct.find(product => product.id === item.id);
  //     console.log('checkProduct', checkProduct)
  //     if (checkProduct) {
  //       query({
  //         method: 'getMallProducts',
  //         params: [
  //           { code: 'tenant', graphqlType: 'String', required: false, value: appState?.tenant },
  //           { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
  //         ],
  //         attributes: []
  //       }).then(({ data }) => {

  //         const foundProduct = data['getMallProducts'].find(product => product.id === checkProduct.id);
  //         console.log('foundProduct', foundProduct)
  //         const newQuantity = checkProduct.cart_quantity + 1
  //         if ((foundProduct.quantity >= newQuantity || foundProduct.quantity === -1)) {
  //           checkProduct.cart_quantity += 1
  //           localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

  //           appDispatch({
  //             type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
  //             payload: {
  //               open: false,
  //               cart: JSON.stringify(addCartProduct)
  //             }
  //           });
  //           appDispatch({
  //             type: APP_STORE_ACTION.SHOW_ALERT,
  //             payload: { description: `Add Cart Successful`, typeAlert: 'success' }
  //           });

  //         } else {
  //           return appDispatch({
  //             type: APP_STORE_ACTION.SHOW_ALERT,
  //             payload: { description: `Quantity exceeds maximum limit of ${foundProduct.quantity}. Please decrease the quantity.`, typeAlert: 'error' }
  //           });
  //         }


  //       }).catch((error) => {

  //       })
  //     } else {
  //       addCartProduct.push(
  //         {
  //           id: item.id,
  //           cart_quantity: 1
  //         })

  //       localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

  //       appDispatch({
  //         type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
  //         payload: {
  //           open: false,
  //           cart: JSON.stringify(addCartProduct)
  //         }
  //       });
  //       appDispatch({
  //         type: APP_STORE_ACTION.SHOW_ALERT,
  //         payload: { description: `Add Cart Successful`, typeAlert: 'success' }
  //       });
  //     }

  //   } else {

  //     addCartProduct.push(
  //       {
  //         id: item.id,
  //         cart_quantity: 1
  //       })

  //     localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

  //     appDispatch({
  //       type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
  //       payload: {
  //         open: false,
  //         cart: JSON.stringify(addCartProduct)
  //       }
  //     });
  //     appDispatch({
  //       type: APP_STORE_ACTION.SHOW_ALERT,
  //       payload: { description: `Add Cart Successful`, typeAlert: 'success' }
  //     });
  //   }


  // };

  // GET DATA

  const onClickAddCart = (event, item) => {
    event.stopPropagation();


    // GET CURRENT CART PRODUCT
    const getCartProduct = localStorage.getItem('cart_product');
    let addCartProduct = (getCartProduct !== null && typeof getCartProduct !== 'undefined') ? JSON.parse(getCartProduct) : []

    // CHECK PRODUCT CURRENT STATUS (EXP: QUANTITY)

    query({
      method: 'getMallProducts',
      params: [
        { code: 'tenant', graphqlType: 'String', required: false, value: appState?.tenant },
        { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
      ],
      attributes: []
    }).then(({ data }) => {

      // FIND PRODUCT
      const foundProduct = data['getMallProducts'].find(product => product.id === item.id);

      // IF FOUND PRODUCT
      if (foundProduct) {
        console.log('foundProduct')
        // CHECK PRODUCT QUANTITY 

        // IF PRODUCT QUANTITY === 0
        if (foundProduct.quantity === 0) {
          console.log('quantity0')

          // IF CART PRODUCT HAVE THIS PRODUCT , WILL REMOVE
          if (addCartProduct.length > 0) {
            const getRemoveProduct = addCartProduct.filter(item => item.id !== foundProduct.id);

            localStorage.setItem("cart_product", JSON.stringify(getRemoveProduct));

            appDispatch({
              type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
              payload: {
                open: false,
                cart: JSON.stringify(getRemoveProduct)
              }
            });
          }

          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: `The current inventory check indicates that the quantity of this mall product is 0; therefore, it cannot be added any further. It will be automatically removed from the previous additions.`, typeAlert: 'error' }
          });

          return;
        } else {

          // FIND PRODUCT 
          let checkProduct = addCartProduct.find(product => product.id === item.id);

          // IF CART PRODUCT HAVE THIS PRODUCT , WILL ADD CART QUANTITY 
          if (addCartProduct.length > 0 && typeof checkProduct !== 'undefined') {

            const newQuantity = checkProduct.cart_quantity + 1

            // IF CHECK PRODUCT QUANTITY CAN ADD 
            if ((foundProduct.quantity >= newQuantity || foundProduct.quantity === -1)) {
              checkProduct.cart_quantity += 1
              localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

              appDispatch({
                type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                payload: {
                  open: false,
                  cart: JSON.stringify(addCartProduct)
                }
              });

              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: `Add Cart Successful`, typeAlert: 'success' }
              });

              return;

            }
            else {
              // IF CHECK PRODUCT CANNOT ADD 

              // IF THIS PRODUCT CURRENT QUANTITY IN CART IS MORE THAN STOCK
              if (checkProduct.cart_quantity > foundProduct.quantity) {
                checkProduct.cart_quantity = foundProduct.quantity
                localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

                appDispatch({
                  type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                  payload: {
                    open: false,
                    cart: JSON.stringify(addCartProduct)
                  }
                });

                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: `The current stock for this product is only ${foundProduct.quantity} items, thus the quantity of this product added to the cart will be adjusted to ${foundProduct.quantity}.`, typeAlert: 'error' }
                });
                return
              } else {
                return appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: `Quantity exceeds maximum limit of ${foundProduct.quantity}. Please decrease the quantity.`, typeAlert: 'error' }
                });
              }


            }

          } else {
            // IF CART PRODUCT DUN HAVE THIS PRODUCT , WILL DIRECT ADD CART  
            console.log('dun have any product just add')

            addCartProduct.push(
              {
                id: item.id,
                cart_quantity: 1
              })

            localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

            appDispatch({
              type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
              payload: {
                open: false,
                cart: JSON.stringify(addCartProduct)
              }
            });

            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: `Add Cart Successful`, typeAlert: 'success' }
            });
          }

        }
      }




    }).catch((error) => {

    })





  };

  useEffect(() => {
    // console.log('shop', dynamicState.selectedFilterType?.code)
    setLoading(true)
    if (dataType === 'product') {

      queries([{
        index: 'getMallProducts',
        method: 'getMallProducts',
        params: [
          { code: 'tenant', graphqlType: 'String', required: false, value: appState?.tenant },
          { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
        ],
        attributes: []
      }, {
        index: 'getMallProductCategories',
        method: 'getMallProductCategories',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' }, order: [['index', 'ASC']] } },
        ],
        attributes: ['code', 'name']
      }]).then(({ data }) => {
        let getPromotionsData = []
        if (filter === 'hot') {
          getPromotionsData = data['getMallProducts']?.filter((item) => item.hot === true)?.map((item) => {
            return { ...item, category: JSON.parse(item.category) };
          })
        } else {
          getPromotionsData = data['getMallProducts']?.map((item) => {
            return { ...item, category: JSON.parse(item.category) };
          })
        }



        const getPromoTypes = [{ code: 'ALL', name: 'show_all' }, ...data['getMallProductCategories'].map(item => item)];

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_ALL_TYPES, payload: data['getMallProductCategories'] })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_FILTER_TYPES, payload: getPromoTypes })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_DEFAULT_DATA, payload: getPromotionsData })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getPromotionsData })
        const getLocation = location.hash ? location.hash?.substring(1) : 'ALL'
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE, payload: getLocation })
        setLoading(false)

      }).catch((error) => {
        // console.log('error: ', error)
        setLoading(false)

      })
    }
    else if (dataType === 'shopping_cart') {

      let getCartProduct = localStorage.getItem('cart_product');
      // console.log(typeof JSON.parse(getCartProduct))
      getCartProduct = JSON.parse(getCartProduct)
      if (getCartProduct.length > 0) {
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getCartProduct })
      }

    }
    else if (dataType === 'promotion') {

      queries([{
        index: 'getPromotions',
        method: 'getPromotions',
        params: [
          { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
          { code: 'appearInWebsite', graphqlType: 'Boolean', required: false, value: true },
          { code: 'haveImage', graphqlType: 'Boolean', required: false, value: true },
        ],
        attributes: []
      }, {
        index: 'getPromotionCategories',
        method: 'getPromotionCategories',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },
        ],
        attributes: ['code', 'name']
      }]).then(({ data }) => {

        const getPromotionsData = data['getPromotions']?.map((item) => {
          return { ...item, category: JSON.parse(item.category) };
        })

        // console.log('getPromotionsData: ', getPromotionsData)
        // const getPromoTypes = getPromotionsData.reduce((result, promo) => {
        //   promo.category.forEach((t) => {
        //     if (result.indexOf(t) === -1) {
        //       result.push(t);
        //     }
        //   });
        //   return result
        // }, ["ALL"])



        //  const getPromoTypes = ['ALL', ...data['getPromotionCategories'].map(item => item)];
        const getPromoTypes = [{ code: 'ALL', name: 'show_all' }, ...data['getPromotionCategories'].map(item => item)];

        // console.log('getPromoTypes', getPromoTypes)

        dynamicDispatch({ type: DYNAMIC_ACTION.SET_ALL_TYPES, payload: data['getPromotionCategories'] })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_FILTER_TYPES, payload: getPromoTypes })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_DEFAULT_DATA, payload: getPromotionsData })
        dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getPromotionsData })

        // console.log('promo', data['getPromotions'])
      }).catch((error) => {
        // console.log('error: ', error)

      })

    }
    else {
      dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: data })
      setLoading(false)

    }
    // console.log('data', data)

  }, [queries, data, dataType, i18n.resolvedLanguage, appState.tenant, location.hash, filter])


  // FILTER LOCATION
  useEffect(() => {

    const getLocation = location.hash ? location.hash?.substring(1) : 'ALL'
    dynamicDispatch({ type: DYNAMIC_ACTION.SET_SELECTED_FILTER_TYPE, payload: getLocation })
  }, [location.hash])





  // FILTER DATA BY TYPE
  useEffect(() => {
    setLoading(true)
    if (dynamicState.selectedFilterType?.code === 'ALL') {

      dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: dynamicState.defaultData })
      setLoading(false)

    }
    else {
      const getFilterData = dynamicState.defaultData.filter(item => {
        // const category = JSON.parse(item.category);
        return item.category?.some(category => category === dynamicState.selectedFilterType?.code);
      });
      dynamicDispatch({ type: DYNAMIC_ACTION.SET_SHOW_DATA, payload: getFilterData })
      console.log('filter hi', dynamicState.selectedFilterType?.code)
      setLoading(false)

    }


  }, [dynamicState.selectedFilterType?.code, dynamicState.defaultData])





  useEffect(() => {
    const userAgent = navigator.userAgent;
    let getDevice = ''

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
      getDevice = 'mobile'
      setDeviceType("mobile");
    } else {
      getDevice = 'desktop'
      setDeviceType("desktop");
    }
    // console.log('getDevice:', getDevice)

  }, [])



  const RemainingTime = ({ lastEffectiveDate }) => {
    const [remainingTime, setRemainingTime] = useState(null);
    const year = dayjs(lastEffectiveDate).year()

    useEffect(() => {
      // const promotionEndTime = dayjs(`${lastEffectiveDate}T${displayEndTime}`);
      const promotionEndTime = dayjs(`${lastEffectiveDate}`);

      const intervalId = setInterval(() => {
        const now = dayjs();
        const timeRemaining = promotionEndTime.diff(now);

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        setRemainingTime({ days, hours, minutes, seconds });
      }, 1000);

      return () => clearInterval(intervalId);
    }, [lastEffectiveDate]);



    return (
      <div className="w-50">
        {remainingTime && (
          <div className="promoDetails_timeShow promotionTime_part">
            <div className="promoDetails_timeShow_container">
              {year >= 2999 ? (<>{t('no_expire_date')}</>) : (<><div className="count_container day_count">
                <div className="count_box">
                  <p>{remainingTime?.days}</p>
                  <p>{t('days')}</p>
                </div>
              </div>
                <div className="count_container time_count">
                  <div className="count_box">
                    <p>{remainingTime?.hours}</p>
                    <p>{t('hour')}</p>
                  </div>
                  <span>:</span>
                  <div className="count_box">
                    <p>{remainingTime?.minutes}</p>
                    <p>{t('min')}</p>
                  </div>
                  <span>:</span>
                  <div className="count_box">
                    <p>{remainingTime?.seconds}</p>
                    <p>{t('sec')}</p>
                  </div>
                </div></>)}

            </div>
          </div>
        )}
      </div>
    );
  };

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, 0);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formattedAmount;
  }

  const getImageSize = (device, size, content, items) => {

    const value = IMAGE_SIZE_DYNAMIC[size] &&
      IMAGE_SIZE_DYNAMIC[size][device] &&
      IMAGE_SIZE_DYNAMIC[size][device][content] &&
      IMAGE_SIZE_DYNAMIC[size][device][content][items];
    return value || null;
  }

  const handleViewMoreClick = (event) => {

    if (dataType === 'product') {
      navigate('/shop')
    }

    if (dataType === 'promotion') {
      window.open(`https://${appState.domain}/promotions`)
    }
  }


  const handleLinkClick = (event, item) => {
    if (dataType === 'product') {
      onChangeProductDetails(item)
    }

    if (dataType === 'promotion') {
      window.open(`https://${appState.domain}/promotions`)
    }

    if (noLink) {
      event.preventDefault();
    }

  };

  if (dataType === 'game' || dataType === 'games') {
    imageSizeDynamic = getImageSize(isDesktopOrLaptop ? 'desktop' : 'mobile', imageSize, contentPosition || 'bottom', isDesktopOrLaptop ? rowDesktop : rowMobile);
  }

  const widthColumn = isDesktopOrLaptop ? (rowDesktop ? 100 / rowDesktop : 0) : (rowMobile ? 100 / rowMobile : 0)
  const showDataLength = !numberOfRow ? dynamicState.showData?.length : (numberOfRow !== -1 ? (isDesktopOrLaptop ? rowDesktop : rowMobile) * numberOfRow : dynamicState.showData?.length)

  if ((desktopToggle || mobileToggle) === true) {
    return (
      <>
        <section className={`section ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"} dynamic_template_1 ${noPadding && 'pb-0'}`} id={`layout_01`}>
          <div id={`${id}`}>
            <div className={`${id}_body ${isDesktopOrLaptop ? '' : `${id}_body_m`} layout_body ${noPadding && 'pb-0'}`}>
              <Container>
                <div className={`${id}_wrap`}>
                  {/* SECTION HEADER */}
                  {titleToggle ?
                    <div className={`section_header`}>
                      <div className="font_h2 section_title">
                        {titleIconToggle && <img src={`${TENANT_BUCKET}/icon/${id}_title_icon.png`} alt="title icon" />}
                        {label && t(label)}</div>
                      <button className="section_details" onClick={(event) => handleViewMoreClick(event)}>
                        {t('view_more')} &nbsp;
                        <AiOutlineRight />
                      </button>
                    </div>
                    : <></>}
                  {
                    filterTabToggle && (
                      <Nav variant="pills" className={`${id}_filterTab filterTab tab_pills_color font_tab_pills`} >
                        {dynamicState.filterTypes?.map(function (item, index) {
                          // let _item = dynamicState.allType.find(e => e.code === item);
                          // const getLocation = location.hash ? location.hash?.substring(1) : 'ALL'
                          // console.log('getLocation', getLocation)
                          return (
                            <div key={item?.code} onClick={() => { onChangeType(item?.code) }}>
                              <div className={`filterTab_selection ${item.code === dynamicState.selectedFilterType?.code ? 'color_active active' : ''}`}>
                                {/* {_item ? _item.name : t('all')} */}
                                {item.code === 'ALL' ? t('show_all') : (dataType === 'product' ? t(`MALL_CATEGORY_${item.code}`) : item.name)}
                                {/* {item.name} */}
                              </div>
                            </div>
                          )
                        })}
                      </Nav>
                    )
                  }
                  {/* {console.log('dynamicState.showData',dynamicState.showData)} */}
                  {/* --- SECTION BODY START --- */}
                  <div className={`row`} style={{ justifyContent: `${cardPosition ?? 'center'}` }}>
                    {Object.values(dynamicState.showData ?? "").slice(0, showDataLength).map((item, index) => {
                      let _item = GAME_MENU_DATA[item.code] ?? ''

                      return (
                        <div style={{ width: widthColumn + '%' }} key={`${dataType}_${filter ?? item.id}_${item.id}_${item.name}_${index} `} className={`card_container`}>
                          <div className={`card_wrap card_image_${imageSize} card_position_${contentPosition} card_action_${actionPosition} type_${dataType} card_${noLink ? 'noLink' : 'link'} rowDesktop_${rowDesktop}`} onClick={(event) => handleLinkClick(event, item)}>
                            {/* <Link to={`${dataType === 'gameTypes' ? _item.url : ((dataType === 'game provider' && filter === 'SL') ? `slots#${item.game_provider}` : '#')}`}> */}
                            {/* --- IMAGE PART START --- */}
                            <figure className="card_image_wrap">
                              {(dataType === 'game' || dataType === 'games') ?
                                <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/img_jpg/${item.code}_${imageSize}_w${imageSizeDynamic}.jpg`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                (dataType === 'game provider' ?
                                  <ImageWithPlaceholder src={`${TENANT_BUCKET}/game-provider/${folderImage !== '' ? `${folderImage}/` : `${imageSize ?? '1x1'}/`}${filter}/${item.game_provider}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                    ((dataType === 'product' || dataType === 'shopping_cart') ?
                                      <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item?._desktop_image?.url) : (item?._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} /> :
                                      <ImageWithPlaceholder src={`${GLOBAL_BUCKET}/game/${item.game_provider}/${imageSize}/${item.code}.png`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/${imageSize}.png`} alt={item.title} />)
                                  ))
                              }
                              {/* IMAGE PART CAPTION */}
                              {contentPosition === 'insideImage' && (<figcaption> <div className="card_content_title">   {
                                (dataType === 'product' || dataType === 'shopping_cart') ?
                                  <>{(t(`${item?.name}`))}</> :
                                  ((dataType === 'promotion' || dataType === 'promotions') ?
                                    <>{item.title}</> :
                                    <>{item.name}</>
                                  )

                              }</div></figcaption>)}

                              {/* --- ACTIVE HOVER (INSIDE IMAGE PART) START --- */}
                              {actionPosition === 'hover' && <div className="card_action_wrap">
                                {
                                  (dataType === 'product') ?
                                    <button className="color_button font_button button_action button_action1" >{item.action_1 ?? t('add_to_cart')}</button> :
                                    ((dataType === 'promotion' || dataType === 'promotions') ?
                                      <>
                                        <button className="color_button font_button button_action button_action1" onClick={() => onChangeProductDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                        {!appState.loggedIn ?
                                          <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</button> :
                                          <button className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</button>}
                                      </> :
                                      <></>
                                    )

                                }


                              </div>}
                              {/* --- ACTIVE HOVER (INSIDE IMAGE PART) END --- */}

                            </figure>
                            {/* --- IMAGE PART END --- */}


                            {(contentPosition !== 'none' && contentPosition !== 'insideImage') && <div className="color_primary content_container">
                              <article className="card_content_wrap">
                                {
                                  ((dataType === 'promotion' || dataType === 'promotions') && Array.isArray(item.category)) &&
                                  <div className="promotionTag_part">
                                    {item.category?.map(function (categoryItem, categoryIndex) {
                                      let _categoryItem = dynamicState.allType.find(e => e.code === categoryItem);
                                      return _categoryItem && (
                                        <label key={categoryIndex}>{_categoryItem.name}</label>
                                      )
                                    })}

                                    {/* <label>New Member</label>
                                  <label>Slot</label>
                                  <label>Live Casino</label> */}
                                  </div>
                                }
                                <div className="card_content_title">   {
                                  (dataType === 'game' || dataType === 'games') ?
                                    <>{(t(`GAME_${item?.id}`))}</> :
                                    ((dataType === 'promotion' || dataType === 'promotions') ?
                                      <>{item.title}</> :
                                      <>{item.name}</>
                                    )

                                }</div>
                                <div className="card_content_desc_container">
                                  {item.description && (
                                    <p className="card_content_desc">{item.description}</p>
                                  )}
                                  {(dataType === 'product') && (
                                    <div className="card_content_desc">
                                      {/* <div className={`product_stock`}>  {t('stock')} : {item?.quantity === -1 ? <BsInfinity /> : item?.quantity}</div> */}
                                      {item.promotion_point && (<div className="promotion_point">{formatAmount(item.promotion_point ?? 0, appState.currencyFormat.decimal_point)} <span className="point_name">{t('point')}</span></div>)}
                                      <div className={`product_point ${item.promotion_point && 'discount'}`}>{formatAmount(item.point ?? 0, appState.currencyFormat.decimal_point)} <span className="point_name">{t('point')}</span></div>
                                    </div>
                                  )}

                                  {
                                    ((dataType === 'promotion' || dataType === 'promotions') && isDesktopOrLaptop) && (
                                      <RemainingTime lastEffectiveDate={item.last_effective_datetime} />
                                    )
                                  }
                                </div>
                              </article>

                              {/* --- ACTIVE BOTTOM START --- */}
                              {actionPosition === 'bottom' && <div className="card_action_wrap">
                                <div className="button_action_part">
                                  {
                                    (dataType === 'product') ?
                                      <button className="color_button font_button button_action button_action1" onClick={(event) => onClickAddCart(event, item)}>{item.action_1 ?? t('add_to_cart')}</button> :
                                      ((dataType === 'promotion' || dataType === 'promotions') ?
                                        <>
                                          <button className="color_button font_button button_action button_action1" onClick={() => onChangeProductDetails(item)} >{item.action_1 ?? t('more_info')}</button>
                                          {!appState.loggedIn ?
                                            <Link to="/register" className="color_button font_button button_action button_action2">{item.action_2 ?? t('join_now')}</Link> :
                                            <Link to="/wallet/transfer" className="color_button font_button button_action button_action2">{item.action_2 ?? t('apply_now')}</Link>}
                                        </> :
                                        <></>
                                      )

                                  } </div>
                                {
                                  (dataType === 'promotion' || dataType === 'promotions') &&
                                  <div className="promotionCode_part">
                                    <label>Use Code</label>
                                    <div className="promotionCode_content"><p>{item?.code}</p> <AiFillCopy onClick={() => copyText(item?.code)} /></div>
                                  </div>
                                }


                              </div>}
                              {/* --- ACTIVE BOTTOM END --- */}

                            </div>}
                            {/* </Link> */}
                          </div>

                        </div>
                      );
                    })}

                  </div>
                  {/* --- SECTION BODY END --- */}
                </div>
              </Container>
            </div>
          </div>
        </section>
        {/* {currentItem && (
          <PromoDetailsDialog
            show={productDetailsDialogShow}
            onHide={() => setProductDetailsDialogShow(false)}
            getdata={currentItem}
          />
        )} */}
        <ProductDetailsDialog show={productDetailsDialogShow} onHide={() => setProductDetailsDialogShow(false)} getdata={currentItem} />
        <TransferBalanceDialog show={transferDialogShow.show} onHide={() => setTransferDialogShow({ ...transferDialogShow, show: false })} balance={transferDialogShow.balance} gameSelect={transferDialogShow.gameSelect} walletAmount={transferDialogShow.walletAmount} />
        {isLoading && <Loading />}
      </>
    );
  }

}



export default Template_01;
